const popUpHotjar = (hotjarEvent: (event: string) => void) => {
    if (hotjarEvent) hotjarEvent('submit_feedback')
}

export {
    popUpHotjar
} 